// extracted by mini-css-extract-plugin
module.exports = {"pencilButton":"style__pencilButton__9DGGG","pencilButtonNote":"style__pencilButtonNote__5m6HY"};